import Image from "next/image";
import classNames from "classnames";

import styles from "./index.module.scss";

const CompanyCardMobile = ({ company, lang, cardType = "column" }) => {
  const { company_logo, company_name, company_tags, active_jobs, company_url } = company || {};

  return (
    <a
      href={`/${lang}/${company_url}`}
      target='_blank'
      className={classNames({
        [styles.company_container_mobile_row]: cardType === "row"
      })}
    >
      <div className={styles.company_container_mobile}>
        <div className={styles.company_left}>
          <div className={styles.company_logo}>
            <Image src={company_logo} width={48} height={48} alt='logo'></Image>
          </div>
          <div className={styles.company_information}>
            <span className={styles.company_name}>{company_name}</span>
            <span className={styles.company_tgs}>{company_tags?.join(" · ")}</span>
          </div>
        </div>
        <div className={styles.company_active}>
          <PackageSvg /> {active_jobs}
        </div>
      </div>
    </a>
  );
};

const PackageSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
    <path
      d='M12.6562 3.15V4.6125H14.1187C15.3303 4.6125 16.3125 5.59468 16.3125 6.80625V14.1187C16.3125 15.3303 15.3303 16.3125 14.1187 16.3125H3.88125C2.66968 16.3125 1.6875 15.3303 1.6875 14.1187V6.80625C1.6875 5.59468 2.66968 4.6125 3.88125 4.6125H5.34375V3.15C5.34375 2.34228 5.99853 1.6875 6.80625 1.6875H11.1937C12.0015 1.6875 12.6562 2.34228 12.6562 3.15ZM6.80625 7.5375H5.34375V6.075H3.88125C3.47739 6.075 3.15 6.40239 3.15 6.80625L3.15 10.4625H14.85V6.80625C14.85 6.40239 14.5226 6.075 14.1187 6.075H12.6562V7.5375H11.1937V6.075H6.80625V7.5375ZM14.85 11.925H3.15L3.15 14.1188C3.15 14.5226 3.47739 14.85 3.88125 14.85H14.1187C14.5226 14.85 14.85 14.5226 14.85 14.1187V11.925ZM11.1937 4.6125V3.15L6.80625 3.15V4.6125H11.1937Z'
      fill='#121212'
    />
  </svg>
);

export default CompanyCardMobile;
